import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './auth.module';
import { user } from './user.module';
import { base } from './base.module';
import { question } from './question.module';
import { test } from './test.module';
import { plan } from './plano.module';
import { theme } from './theme.module';
import { specialty } from './specialty.module';
import { profile } from './profile.module';
import { product } from './product.module';
import { error } from './erro.module';
import { contato } from './contato.module';
import { prova } from './prova.module'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    user,
    base,
    question,
    test,
    plan,
    theme,
    specialty,
    profile,
    product,
    error, 
    contato, 
    prova
  },
});
